import {Stack, Typography, Box, ListItemButton } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import React, { useState } from 'react';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

export const AnalysisCard = ({name, value, ratings, details, status, barData, keyName, diastolicbp, diastolicbpRatings, diastolicbpDescription}) => {
	const isSmallScreen = useMediaQuery(theme => theme.breakpoints.down('sm'));
	const isSmallScreenThenLG = useMediaQuery(theme => theme.breakpoints.down('lg'));
	const isGalaxyFold = useMediaQuery('(max-width:280px)');
	const [collapsableBpDetailBox, setCollapsableBpDetailBox] = useState({
        diastolicbpCard: true,
        systolicBpCard:  false
    });

	 // Function to toggle the collapsable box
	const toggleBpCollapsableBox = () => {
		setCollapsableBpDetailBox(prevState => ({
            diastolicbpCard: !prevState.diastolicbpCard,
            systolicBpCard: !prevState.systolicBpCard
        }));
	};


	return (
		<Box
			sx={{
				// background: 'linear-gradient(180deg, #FCFCFC 0%, #E4E3E3 100%)',
				// borderRadius: '10px',
				padding: '20px',
				marginTop: '20px',
				minHeight: '290px',
				display: 'flex',
				flexDirection: 'column',
				justifyContent: 'center',
				background : "red",
				borderRadius: '15px',
				background: '#FFF',
				boxShadow: isSmallScreenThenLG ? 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px' : `
				  0px 230px 64px 0px rgba(0, 0, 0, 0.00),
				  0px 147px 59px 0px rgba(0, 0, 0, 0.01),
				  0px 83px 50px 0px rgba(0, 0, 0, 0.05),
				  0px 37px 37px 0px rgba(0, 0, 0, 0.09),
				  0px 9px 20px 0px rgba(0, 0, 0, 0.10)
				`,
				
			}}
			// className='analysis-card-shadow'
		>
			<Stack display="flex" flexDirection="row" justifyContent="space-between" >
				{/* Analysis Info Box Satrts */}
				<Box>
					<Typography
						color="black"
						variant="h4"
						component="h4"
						fontWeight="bold"
						sx={{
							fontWeight: '600',
							fontSize: isGalaxyFold ? '20px' : isSmallScreen ? '20px' : '20px',
						}}
					>
						{name}
					</Typography>

					<Box display="flex" flexDirection="row" alignItems="end" marginTop="10px">
						<Typography
							color="black"
							variant="h4"
							component="h4"
							fontWeight="bold"
							sx={{
								fontWeight: '700',
								fontSize: isGalaxyFold ? '25px' : isSmallScreen ? '25px' : '25px',
							}}
						>
							{value < 100 ? value.toPrecision(2) : Math.round(value)}
						</Typography>
						{
							name == 'Blood Pressure' &&
							<Typography
								color="black"
								variant="h4"
								component="h4"
								fontWeight="bold"
								sx={{
									fontWeight: '700',
									fontSize: isGalaxyFold ? '25px' : isSmallScreen ? '25px' : '25px',
								}}
							>
								{diastolicbp != null && `/${Math.round(diastolicbp)}`}
							</Typography>

						}
						<Typography
							color="black"
							variant="h4"
							component="h4"
							fontWeight="bold"
							sx={{
								fontWeight: '600',
								paddingLeft: '6px',
								paddingBottom: '6px',
								fontSize: isGalaxyFold ? '10px' : isSmallScreen ? '10px' : '10px',
							}}
						>
							{keyName}
						</Typography>
					</Box>
				</Box>
				{/* Analysis Info Box Ends */}

				<Box display="flex" flexDirection="column">
					<Typography
						color="#A6E177"
						variant="p"
						component="p"
						fontWeight="bold"
						sx={{
							fontWeight: '600',
							textAlign: 'center',
							fontSize: isGalaxyFold ? '12px' : isSmallScreen ? '12px' : '12px',
						}}
					>
						{status.name}
					</Typography>
				</Box>
				{/* <Stack spacing={1}>
					<svg xmlns="http://www.w3.org/2000/svg" width="117" height="47" viewBox="0 0 117 47" fill="none">
						<path
							d="M2 45V45C21.9554 42.2268 39.3601 30.0274 48.774 12.2149L51.891 6.31717C55.1715 0.110054 64.0099 -0.0362423 67.494 6.05891L73.2738 16.1702C82.0967 31.6052 97.4419 42.2076 115 45V45"
							stroke="#A1A0A0"
							stroke-opacity="0.54"
							stroke-width="3"
							stroke-linecap="round"
						/>
						<circle
							cx={
								[...Object.values(ratings)]
									.filter(([min, max]) => value >= min && value <= max)
									.reduce((a, b) => a + b, 0) / 2
							}
							r="3"
							fill={status.color}
						/>
					</svg>
					<svg xmlns="http://www.w3.org/2000/svg" width="117" height="4" viewBox="0 0 117 4" fill="none">
						<path d="M2 2L115 2.00001" stroke={status.color} stroke-width="3" stroke-linecap="round" />
					</svg>
				</Stack> */}
			</Stack>

			{
				name === 'Blood Pressure' &&
				<ListItemButton onClick={toggleBpCollapsableBox} sx={{ width: '100%' }}>
					<Stack display="flex" alignItems='center' padding='8px 2px 0px 0px'>

						{collapsableBpDetailBox.diastolicbpCard ? <ExpandLess /> : <ExpandMore />}
					</Stack>
					<Stack display="flex" alignItems='center' flexDirection="row" justifyContent='space-between' width='100%'>
						<Typography
							color="black"
							variant="h4" component="h4" fontWeight="bold"
							sx={{
								marginTop: 2,
								marginBottom: 1,
								fontWeight: "600",
								fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '14px',
							}}
						>
							Systolic Blood Pressure
						</Typography>
						<Typography
							color="black"
							variant="h4" component="h4" fontWeight="bold"
							sx={{
								marginTop: 2,
								marginBottom: 1,
								fontWeight: "600",
								fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '14px',
							}}
						>
							{value < 100 ? value.toPrecision(2) : Math.round(value)}
						</Typography>
					</Stack>
				</ListItemButton>

			}

			{/* Range Bars Starts */}

			<Collapse in={collapsableBpDetailBox.diastolicbpCard} timeout="auto" unmountOnExit>
				<Stack className="custom-ranges" marginTop={1}>
					{/* Ranges List */}

					<Stack direction="row" width={1} alignItems="center">
						{Object.entries(ratings).map(
							([name, [min, max]], index) =>
								name != 'scheme' && (
									<Stack flex={1} key={name} spacing={0.5}>
										<Box width={1} display="flex" flexDirection="row" justifyContent="center">
											<span className="range-txt opt-range-txt pb-3px" style={{fontSize: 9}}>
												{min}
											</span>
										</Box>
										<Box
											className="range-box"
											width={1}
											display="flex"
											flexDirection="row"
											justifyContent="center"
											alignItems="center"
											height={12}
										>
											<Box
												sx={{
													width: 12,
													height: 12,
													borderRadius: '50%',
													backgroundColor: 'white',
													boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
													position: 'absolute',
												}}
												style={{display: value >= min && value <= max ? 'block' : 'none'}}
											></Box>
											<Box
												sx={{
													height: 8,
													width: 1,
													bgcolor: barData[name]?.color,
													borderTopLeftRadius: (index === 0 || (index === 1 && ratings.scheme !== undefined)) ? 4 : 0,
													borderBottomLeftRadius: (index === 0 || (index === 1 && ratings.scheme !== undefined)) ? 4 : 0,
													borderTopRightRadius: index + 1 === Object.keys(ratings).length ? 4 : 0,
													borderBottomRightRadius: index + 1 === Object.keys(ratings).length ? 4 : 0,
												}}
												width={1}
											></Box>
										</Box>
										<Box width={1} display="flex" flexDirection="row" justifyContent="center">
											<span className="range-txt opt-range-txt pt-3px" style={{fontSize: 9}}>
												{barData[name]?.text}
											</span>
										</Box>
									</Stack>
								),
						)}
					</Stack>

					{/* Ranges List / */}
				</Stack>
				{/* Range Bars Ends */}

				<Box marginTop={2}>
					<Typography
						color="black"
						variant="p"
						component="p"
						fontWeight="bold"
						sx={{
							fontWeight: '400',
							fontSize: isGalaxyFold ? '13px' : isSmallScreen ? '13px' : '13px',
							lineHeight: '15px',
						}}
					>
						{details}
					</Typography>
				</Box>
			</Collapse>

			{/* Diastolic heading Starts */}
			{
				name == 'Blood Pressure' &&
				<Box>
					<ListItemButton onClick={toggleBpCollapsableBox} sx={{ width: '100%' }}>
						<Stack display="flex" alignItems='center' padding='8px 2px 0px 0px'>
							{collapsableBpDetailBox.systolicBpCard ? <ExpandLess /> : <ExpandMore />}
						</Stack>
						<Stack display="flex" alignItems='center' flexDirection="row" justifyContent='space-between' width='100%'>
							<Typography
								color="black"
								variant="h4" component="h4" fontWeight="bold"
								sx={{
									marginTop: 2,
									marginBottom: 1,
									fontWeight: "600",
									fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '14px',
								}}
							>
								Diastolic Blood Pressure
							</Typography>
							<Typography
								color="black"
								variant="h4" component="h4" fontWeight="bold"
								sx={{
									marginTop: 2,
									marginBottom: 1,
									fontWeight: "600",
									fontSize: isGalaxyFold ? '14px' : isSmallScreen ? '14px' : '14px',
								}}
							>
								{diastolicbp != null && `${Math.round(diastolicbp)}`}
							</Typography>
						</Stack>
					</ListItemButton>
					<Collapse in={collapsableBpDetailBox.systolicBpCard} timeout="auto" unmountOnExit>
						{/* Range Bars Starts */}
						<Stack className="custom-ranges" marginTop={1}>
							{/* Ranges List */}

							<Stack direction="row" width={1} alignItems="center">
								{Object.entries(diastolicbpRatings).map(
									([name, [min, max]], index) =>
										name != 'scheme' && (
											<Stack flex={1} key={name} spacing={0.5}>
												<Box width={1} display="flex" flexDirection="row" justifyContent="center">
													<span className="range-txt opt-range-txt pb-3px" style={{ fontSize: 9 }}>
														{min}
													</span>
												</Box>
												<Box
													className="range-box"
													width={1}
													display="flex"
													flexDirection="row"
													justifyContent="center"
													alignItems="center"
													height={12}
												>
													<Box
														sx={{
															width: 12,
															height: 12,
															borderRadius: '50%',
															backgroundColor: 'white',
															boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.25)',
															position: 'absolute',
														}}
														style={{ display: diastolicbp >= min && diastolicbp <= max ? 'block' : 'none' }}
													></Box>
													<Box
														sx={{
															height: 8,
															width: 1,
															bgcolor: barData[name]?.color,
															borderTopLeftRadius: (index === 0 || (index === 1 && diastolicbpRatings.scheme !== undefined)) ? 4 : 0,
															borderBottomLeftRadius: (index === 0 || (index === 1 && diastolicbpRatings.scheme !== undefined)) ? 4 : 0,
															borderTopRightRadius: index + 1 === Object.keys(diastolicbpRatings).length ? 4 : 0,
															borderBottomRightRadius: index + 1 === Object.keys(diastolicbpRatings).length ? 4 : 0,
														}}
														width={1}
													></Box>
												</Box>
												<Box width={1} display="flex" flexDirection="row" justifyContent="center">
													<span className="range-txt opt-range-txt pt-3px" style={{ fontSize: 9 }}>
														{barData[name]?.text}
													</span>
												</Box>
											</Stack>
										),
								)}
							</Stack>

							{/* Ranges List / */}
						</Stack>
						{/* Range Bars Ends */}

						<Box marginTop={2}>
							<Typography
								color="black"
								variant="p"
								component="p"
								fontWeight="bold"
								sx={{
									fontWeight: '400',
									fontSize: isGalaxyFold ? '13px' : isSmallScreen ? '13px' : '13px',
									lineHeight: '15px',
								}}
							>
								{diastolicbpDescription}
							</Typography>
						</Box>
					</Collapse>



				</Box>
			}
		</Box>
	);
};
